/** Query website hit rows using one or more filter criteria. */
export const websiteHitQuerySpec = {
    uri: '/website-hit/query',
    method: 'POST',
    adminOnly: true,
};
